import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  PcrPayScale,
  PcrPayScaleFilter
} from '../../lib/types/models/pcr-pay-scales/pcr-pay-scale'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPcrPayScales(input: PaginationRequest<PcrPayScaleFilter>) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.pcrPayScale.getAll.url, null),
        input
      )
    )
    .get<PaginationResponse<PcrPayScale>>()
}
